declare namespace $ {

	type $mol_text__text_bog_card_header_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_card_header_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_bog_card_header_3 = $mol_type_enforce<
		ReturnType< $bog_card_header['title'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_card_header_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	export class $bog_card_header extends $mol_view {
		Logo_text( ): $mol_text
		Logo( ): $mol_view
		title( ): string
		subtitle( ): string
		Header( ): $mol_labeler
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=header.view.tree.d.ts.map